import db from "../data/argali_db.json";

export const API = "/api";

const clone = (value) => JSON.parse(JSON.stringify(value));
const ok = (data) => Promise.resolve({ data: clone(data) });
const fail = (message, status = 400) => {
  const error = new Error(message);
  error.response = { status, data: { detail: message } };
  return Promise.reject(error);
};

const excursionById = Object.fromEntries(db.excursions.map((e) => [e.id, e]));

const buildGeoJson = () => ({
  type: "FeatureCollection",
  features: db.places.map((p) => ({
    type: "Feature",
    geometry: { type: "Point", coordinates: [p.lng, p.lat] },
    properties: {
      id: p.id,
      name_ru: p.name_ru,
      name_en: p.name_en,
      district: p.district,
      category: p.category,
      photo_id: p.photo_id,
      coordinate_accuracy: p.coordinate_accuracy,
      excursions: (p.excursion_ids || [])
        .map((id) => excursionById[id])
        .filter(Boolean)
        .map((e) => ({
          id: e.id,
          slug: e.slug,
          title_ru: e.title_ru,
          title_en: e.title_en,
          seasons: e.seasons || [],
        })),
    },
  })),
});

const parsePath = (rawPath) => {
  const fakeBase = typeof window !== "undefined" ? window.location.origin : "https://argali-altai.com";
  const url = new URL(rawPath, fakeBase);
  return { pathname: url.pathname, params: url.searchParams };
};

const remote = async (method, path, payload) => {
  const headers = { Accept: "application/json" };
  const token = typeof window !== "undefined" ? localStorage.getItem("argali_token") : null;
  if (token) headers.Authorization = `Bearer ${token}`;
  if (payload !== undefined) headers["Content-Type"] = "application/json";

  let response;
  try {
    response = await fetch(`${API}${path}`, {
      method,
      headers,
      body: payload === undefined ? undefined : JSON.stringify(payload),
    });
  } catch {
    return fail("Не удалось связаться с сервером. Попробуйте ещё раз.", 503);
  }

  let data = null;
  try { data = await response.json(); } catch { data = null; }
  if (!response.ok) {
    const message = data?.detail || `Request failed (${response.status})`;
    const error = new Error(message);
    error.response = { status: response.status, data: data || { detail: message } };
    throw error;
  }
  return { data };
};

const getStatic = (rawPath) => {
  const { pathname } = parsePath(rawPath);
  if (pathname === "/places") return db.places;
  if (pathname === "/photos") {
    return db.photos
      .filter((p) => p.verified_for_commercial_reuse === true)
      .map((p) => ({ ...p, local_url: `/photos/${p.id}.jpg` }));
  }
  if (pathname === "/legal-notes") return db.legal_notes;
  if (pathname === "/geojson") return buildGeoJson();
  throw Object.assign(new Error(`Static endpoint not found: ${pathname}`), { status: 404 });
};

const dynamicGet = (pathname) =>
  pathname === "/site" ||
  pathname === "/excursions" ||
  pathname.startsWith("/excursions/") ||
  pathname.startsWith("/auth/") ||
  pathname.startsWith("/admin/") ||
  pathname === "/schedule" ||
  pathname.startsWith("/schedule/") ||
  pathname === "/guide-journal" ||
  pathname.startsWith("/guide-journal/");

export const api = {
  get(path) {
    const { pathname } = parsePath(path);
    if (dynamicGet(pathname)) return remote("GET", path);
    try { return ok(getStatic(path)); }
    catch (error) { return fail(error.message || "Not found", error.status || 404); }
  },

  async post(path, payload = {}) {
    return remote("POST", path, payload);
  },

  patch(path, payload = {}) { return remote("PATCH", path, payload); },
  put(path, payload = {}) { return remote("PUT", path, payload); },
  delete(path) { return remote("DELETE", path); },
};

export const L = (obj, field, lang) => {
  if (!obj) return "";
  return obj[`${field}_${lang}`] || obj[`${field}_ru`] || obj[`${field}_en`] || "";
};

export const photoUrl = (photoId) => (photoId ? `/photos/${photoId}.jpg` : undefined);

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Что-то пошло не так. Попробуйте ещё раз.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const priceLabel = (exc, lang) => {
  if (exc && exc.price_from_rub != null) {
    return `${lang === "ru" ? "от" : "from"} ${exc.price_from_rub.toLocaleString("ru-RU")} ₽`;
  }
  return lang === "ru" ? "Цена по запросу" : "Price on request";
};